<script setup lang="ts">
import type { SetupResponseModel } from '@su4r-frontend/api';

const logger = useLogger();
const { alertSettings, hideAlert } = useAlertToast();
const { locale } = useI18n();
const { payload, static: nuxtAppStatic } = useNuxtApp();
const translatedRoutes = useTranslatedRoutes();

const { data, error } = await useFetch('/api/route/setup', {
    key: `setup-${locale.value}`,
    query: {
        culture: locale.value,
    },
    watch: [locale],
    getCachedData(key) {
        return (payload.data[key] ?? nuxtAppStatic.data[key]) as SetupResponseModel | undefined;
    },
});

if (!data.value) {
    logger.error('[SETUP ERROR]', error.value);
    throw createError({
        statusCode: error.value?.statusCode,
        statusMessage: error.value?.statusMessage,
        message: error.value?.message,
        fatal: true,
    });
}

translatedRoutes.value = {
    login: data.value.loginUrl ?? '',
    prescribe: data.value.prescribeUrl ?? '',
    register: data.value.registerUrl ?? '',
};
</script>

<template>
    <div
        v-if="data"
        class="bg-blue-heavy flex min-h-screen flex-col bg-cover bg-no-repeat"
        style="background-image: url('/img/bg-logos.svg')">
        <MainHeader v-if="data?.header" class="print:hidden" :data="data.header" />
        <main id="main-content" class="flex flex-1 flex-col pt-4 lg:pt-6">
            <slot></slot>
        </main>
        <MainFooter v-if="data?.footer" class="print:hidden" :data="data.footer" />
        <ClientOnly>
            <Teleport to="body">
                <AlertToast :alert-settings="alertSettings" @hide-alert="hideAlert" />
            </Teleport>
        </ClientOnly>
    </div>
</template>
